import type { ReactNode } from "react";

import { LastUsedPill } from "./LastUsedPill";

import * as styles from "./LastUsedPill.styles";

interface Props {
  children: ReactNode;
  enabled?: boolean;
  isActive?: boolean;
}

const LastUsedPillOverlay = ({ children, enabled = false, isActive = false }: Props) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <div css={styles.container}>
      {children}
      {isActive ? <LastUsedPill /> : null}
    </div>
  );
};

export { LastUsedPillOverlay };
